export default __webpack_public_path__ + "static/media/GitHub.dc49a960.svg";